import { render, staticRenderFns } from "./fourSSO.vue?vue&type=template&id=c07131fa&"
import script from "./fourSSO.vue?vue&type=script&lang=js&"
export * from "./fourSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports